import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../../../utils";
import { Avatar, AvatarFallback, AvatarImage } from "../../base/avatar/avatar";
/** The `UserDisplayIdentity` chip: thumbnail if there is one, initials if not. */ export function IdentityAvatar({ identity, className }) {
    return /*#__PURE__*/ _jsxs(Avatar, {
        size: "xs",
        className: cn("shrink-0", className),
        children: [
            identity?.avatarUrl && /*#__PURE__*/ _jsx(AvatarImage, {
                src: identity.avatarUrl,
                alt: identity.name
            }),
            /*#__PURE__*/ _jsx(AvatarFallback, {
                className: "text-3xs",
                children: identity?.initials ?? "?"
            })
        ]
    });
}

//# sourceMappingURL=identity-avatar.js.map